import {LOAN_LIBRARY_QUEUE_STATUS} from "./loanLibraryQueueFactory";

export const filterQueueByStatus = (queue: Record<string, any>[], isPending: boolean) => {
    if (!queue || queue.length === 0) return [];
    
    return isPending
        ? queue.filter((q: Record<string, any>) => 
            q.status === LOAN_LIBRARY_QUEUE_STATUS.Pending || 
            q.status === LOAN_LIBRARY_QUEUE_STATUS.Waitlist
          )
        : queue.filter((q: Record<string, any>) => 
            q.status === LOAN_LIBRARY_QUEUE_STATUS.ReadyForProcessing || 
            q.status === LOAN_LIBRARY_QUEUE_STATUS.WaitlistProcessing
          );
};

export const getAllDuplicateCatalogItemsForQueue = (formData: Record<string, any>, pendingQueue: Record<string, any>[], processingQueue: Record<string, any>[]) => {
    const selectedPendingItems = pendingQueue.filter((item: Record<string, unknown>) => 
        formData.loanLibraryQueueItemIds.includes(String(item.loanLibraryQueueId))
    );

    const duplicates = selectedPendingItems.filter((pendingItem: Record<string, any>) =>
        processingQueue.some((processingItem: Record<string, any>) => 
            processingItem.loanLibraryCatalogItemId === pendingItem.loanLibraryCatalogItemId
        )
    );

    return duplicates;
};

export const createConfirmationMessageForDuplicates = (duplicates: Record<string, any>[], hasDuplicates: boolean) => {
    if (!hasDuplicates) return "";

    const duplicateTitles = duplicates.map((d: Record<string, any>) => `"${d.productName}"`).join(", ");
    
    return `The following items are already being processed: ${duplicateTitles}. ` +
           `Are you sure you want to assign duplicates?`;
};
